<!-------------------Banner starts------------------------------>
<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="position-relative w-100">
            <div class="d-flex align-items-center h-100 w-100">

                <img src="../../../assets/images/banners/futeckcasestudy_bannarimage.png"
                    alt="Banner mit" class=" img img-responsive w-100 h-100 d-none d-md-block">

                <!-- Md -->
                <img src="../../../assets/images/banners/futeckcasestudy_mobilebannar.png"
                    class="img img-responsive d-block d-md-none" width="100%" alt="futeck casestudy" />
                <!-- Md -->

                <div class="position-absolute w-100 home-banner">
                    <div class="row h-100 w-100">
                        <div class="col-md-4 col-sm-12">
                            <div class="banner-section">
                                <div class="align-items-center global_title global_banner_title  title_banner_content futek-title"  role="heading" aria-level="1">
                                    <span>Supercharging with Cloud</span>
                                </div>
                                <div class="global_sub_title global_banner_subtitle mt-3">
                                    <span> Learn how FUTEK, a leading sensor technology giant takes the leap to cloud
                                        for
                                        a major IT transformation and innovation.</span>
                                </div>
                                <div class="col pt-lg-3 pt-5 mt-lg-3">
                            <a href="contact" class="global_button text-left text-white white_button" role="button"  aria-label="View Contact Page" tabindex="0">
                            <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="arrow click" /></div>
                            EXPLORE  </a>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class=" banner-subsection col">
         <h5>Trusted by Global Technology companies</h5>
         </div> -->
    </div>
</div>
<!-------------------Banner ends------------------------------>

<div id="main-wrapper">
    <div class="site-wrapper-reveal">
        <div class="vision-overview section-space--pt_100">
            <div class="row">
                <div class="col-lg-1"></div>
                <div class="col-lg-5">
                    <div class="heading global_section_header futeck_mediaquares"  role="heading" aria-level="1">
                        <b class="futek_content">
                            Empowering manufacturing with automation, intelligent tools and connected ecosystem.
                        </b>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="portfolio-details-content">
                        <div class="text ">
                            <div class="global_section_content pressure_futek futeck_mediaquares">FUTEK, a niche manufacturer of load
                                cell, pressure, torque sensors reimagine to stand out in a competitive market,
                                speed up its operations to meet evolving customer expectations, and warm up for the next
                                stage of growth. The company started the journey to modernize
                                the ecommerce site, marketing platform and infrastructure to meet the customer needs.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>


        <div class="row mt-5">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="global_section_content casestudy_subheading futeck_mediaquares">
                    Maganti IT Resources started the journey with FUTEK to revamp ecommerce site, custom integration
                    with Oracle suite of applications and automate their cloud infrastructure. Maganti IT
                    collaboratively worked with them to improve
                    User experience and enhance brand visibility. The ongoing standardization and automation of IT
                    support services has decreased infrastructure- provisioning time and the flexibility of IT
                    operations made the company to meet changes of demand across its business cycle.
                    Maganti IT provided extensive expertise in process automation with custom integration and with
                    seamless delivery. Our technology resilience and web designing skills delivered the following
                    solutions and services to FUTEK:
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
    <!--====== Casestudy Requirements End ======-->



    <!--====== Casestudy listitems start ======-->

    <div>
        <div class="row">
            <div class="col-lg-2"></div>
            <div class="col-lg-4">
                <div class="futeckcasestudy_mainheading">
                    <ul
                        class="mt-5 ml-5 global_section_content casestudy_listitems futeck_ulitems futeck_mediaquaresul">
                        <li class="futeck_liitems">Ecommerce site implementation</li>
                        <li class="futeck_liitems">Search Engine Optimization</li>
                        <li class="futeck_liitems">Enhanced site performance and speed</li>
                        <li class="futeck_liitems">Oracle EBS modules implementation</li>
                        <li class="futeck_liitems">Avalara Tax Service integration</li>
                        <li class="futeck_liitems">Azure Infrastructure - cloud computing service to maintain database
                            and give access to data
                            remotely</li>
                        <li class="futeck_liitems">Data migration</li>
                        <li class="futeck_liitems">Platform upgradation</li>
                        <li class="futeck_liitems">Ongoing Back end and Infrastructure support</li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-5">
                <img src="../../../assets/images/futeckcasestudy/futeckcasestudy_image.png"
                    alt="futeck mediasquare" class="img-responsive futeckcasestudy_image futeck_mediaquares">
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>


   

    <section class="employee-carosel">
        <div class="testimonial-slider-area pt-5">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title-wrap text-center section-space--mb_40">
                            <div class="global_section_header">Related Capabilities</div>
                            <div class="global_section_content pt-4">Transform applications to outperform in a
                                cloud-first, mobile-first world while modernizing</div>
                            <div class="global_section_content">legacy enterprise applications to accelerate to the pace
                                of business.</div>
                        </div>
                    </div>
                </div>

                <div class="testimonial-slider">
                   
                    <swiper-container #empSwiperContainer class="testimonial-slider__container" slides-per-view="2"
                        [autoplay]="{ delay: 3000 }" 
                        [pagination]="{  clickable: true }"
                        [loop]="true"
                        [breakpoints]="swiperBreakpoints"
                        >
                        <swiper-slide class="employee-slider">
                            <div class="recognition-employees testimonial-slider__one wow move-up">
                                <div class="testimonial-slider__author"
                                style="display: flex; justify-content: start;padding: 1rem;">
                                <img src="../../../assets/images/futeckcasestudy/AIautomation.png"
                                    class="author-image img-fluid" alt="futeckcasestudy">
                                <div class="global_sub_title text-black p-3">
                                     <h2 class="pt-3">Data and Analytics</h2>
                                </div>
                            </div>
                                <div class="testimonial-slider--info">
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        Leverage our advanced data and analytics solutions to transform data into
                                        useful insights. We focus on areas such as inventory updates,
                                        financial transactions, operating system data, process parameters, quality
                                        events, and machine data to uncover new insights through advanced
                                        analytical tools and technologies.
                                    </div>
                                </div>
                               
                            </div>
                        </swiper-slide>
                        <swiper-slide class="employee-slider">
                            <div class="recognition-employees testimonial-slider__one wow move-up">
                                <div class="testimonial-slider__author"
                                style="display: flex; justify-content: start;padding: 1rem;">
                                    <img src="../../../assets/images/futeckcasestudy/dataanalyst.png" class="img-fluid" alt="ai automation">
                                <div class="global_sub_title text-black p-3">
                                    <h2 class="pt-2">AI and Automation</h2>
                                </div>
                            </div>
                                <div class="testimonial-slider--info">
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        AI-based technologies have inevitably changed the way goods and services are
                                        planned and produced today. It is implemented in case scenarios such as
                                        Predictive
                                        Maintenance to Forecast The remaining Useful Life of Equipment, Robotic
                                        Process Automation to Streamline Paperwork, Quality Assurance &amp; Inspection,
                                        Demand Forecasting
                                        to Improve Supply Chain Efficiency and warehouse Automation.
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="employee-slider">
                            <div class="recognition-employees testimonial-slider__one wow move-up">
                                <div class="testimonial-slider__author"
                                    style="display: flex; justify-content: start;padding: 1rem;">
                                    <img src="../../../assets/images/futeckcasestudy/cloudcomputing.png"
                                        class="img-fluid" alt="cloud computing">
                                        <div class="global_sub_title text-black p-3">
                                            <h2 class="pt-2">Cloud computing & lean processes</h2>
                                        </div>                                            
                                </div>
                                <div class="testimonial-slider--info">
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        Maganti IT combines its DevOps and Cloud expertise to assist clients in
                                        scaling up by utilising industry-leading techniques and platforms.
                                        To better serve you, we collaborate with renowned cloud service providers
                                        like Microsoft Azure, Amazon Web Services, and Google Cloud.
                                    </div>
                                </div>

                                
                            </div>
                        </swiper-slide>

                        <swiper-slide class="employee-slider">
                            <div class="recognition-employees testimonial-slider__one wow move-up">
                                <div class="testimonial-slider__author"
                                style="display: flex; justify-content: start;padding: 1rem;">
                                <img src="../../../assets/images/futeckcasestudy/digitaltransformation.png"
                                class="img-fluid" alt="digital transformation">
                                <div class="global_sub_title text-black p-3">
                                    <h2 class="pt-1">Digital Transformation</h2>
                                </div> 
                            </div>
                                <div class="testimonial-slider--info">
                                    <div class="global_section_content recognition-slider testimonial-slider__text">
                                        Digitalization and automation are the game-changers for mastering the
                                        challenges of today and tomorrow. Upgrade your enterprise
                                        with next-gen IoT and digital transformation to get ahead in your industry.
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination"></div>
                    </swiper-container>
                </div>
                  
            </div>
        </div>
    </section>
<!--====== Casestudies Carousel End  ======-->






